(function () {
  function showMessage(el, text) {
    if (!el) return;
    if (text) el.textContent = text;
    el.hidden = false;
  }

  function hideMessage(el) {
    if (!el) return;
    el.hidden = true;
  }

  document.querySelectorAll('[data-contest-giveaway-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var scriptUrl = (form.dataset.scriptUrl || '').trim();
      var submitBtn = form.querySelector('[type="submit"]');
      var successEl = form.querySelector('[data-form-success]');
      var errorEl = form.querySelector('[data-form-error]');
      var defaultError = form.dataset.errorMessage || 'Something went wrong. Please try again.';
      var successMessage = form.dataset.successMessage || 'Thank you! Your entry has been submitted.';

      hideMessage(successEl);
      hideMessage(errorEl);

      if (!scriptUrl) {
        showMessage(errorEl, 'Form is not connected yet. Add your Google Apps Script URL in the theme editor.');
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var formData = new FormData(form);
      var payload = {
        token: form.dataset.secretToken || '',
        first_name: formData.get('first_name'),
        instagram_handle: formData.get('instagram_handle'),
        email: formData.get('email'),
        consent: formData.get('consent') === 'on',
        page_url: window.location.href
      };

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      fetch(scriptUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain;charset=utf-8'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (!result || !result.success) {
            throw new Error((result && result.error) || defaultError);
          }

          form.reset();
          if (successEl) successEl.textContent = successMessage;
          showMessage(successEl);
        })
        .catch(function (error) {
          showMessage(errorEl, error.message || defaultError);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  });
})();
